/**
 * Standard components are globally registered.
 * Any .vue file in this directory is automatically imported and registered.
 * Components must be prefixed with "Standard"
 */

// Vite glob import - automatically imports all .vue files in this directory
const modules = import.meta.glob('./*.vue', { eager: true });

// Build standard components object from glob imports
export const standardComponents = {};

for (const path in modules) {
  const name = path.match(/\.\/(.*)\.vue$/)[1];
  standardComponents[name] = modules[path].default;
}

export function registerStandardComponents(app) {
  Object.entries(standardComponents).forEach(([name, component]) => {
    app.component(name, component);
  });
}
